import './lib/readmore-fixed';

$(function () {
    if (screen.width < 767) {
        $('.filter').readmore({
            embedCSS: true,
            moreLink: '<a href="#" class="btn btn--primary btn--primary--blue"><div class="btn__arrow"><i class="icon icon-arrow-right"></i></div>Toon filters</a>',
            lessLink: '<a href="#" class="btn btn--primary btn--primary--blue mt-4" onclick="window.scrollTo(\'.rw-kenmerken__content\')"><div class="btn__arrow"><i class="icon icon-arrow-right"></i></div>Verberg filters</a>',
            collapsedHeight: 0,
        });
        $('.team-items').readmore({
            embedCSS: true,
            moreLink: '<a href="#" class="btn btn--primary btn--primary--blue"><div class="btn__arrow"><i class="icon icon-arrow-right"></i></div>Meer teamleden</a>',
            lessLink: '<a href="#" class="btn btn--primary btn--primary--blue mt-4" onclick="window.scrollTo(\'.rw-kenmerken__content\')"><div class="btn__arrow"><i class="icon icon-arrow-right"></i></div>Toon minder</a>',
            collapsedHeight: 1200,
        });
    }
});
